<div class="no-content">
    <picture>
        <source
            srcset="/assets/icon/Logo-Light.svg"
            media="(prefers-color-scheme: light), (prefers-color-scheme: no-preference)" />
        <source
            srcset="/assets/icon/Logo-White.svg"
            media="(prefers-color-scheme: dark)" />
        <img
            class="logo"
            style="max-width: 160px;"
            src="/assets/icon/Logo-Light.svg"
            alt="RISE SMS" />
    </picture>
    <div class="wrap">
        <picture>
            <source
                [srcset]="errorConfig.image.light"
                media="(prefers-color-scheme: light), (prefers-color-scheme: no-preference)" />
            <source
                [srcset]="errorConfig.image.dark"
                media="(prefers-color-scheme: dark)" />
            <img
                class="no-assessment"
                [src]="errorConfig.image.light"
                [alt]="errorType" />
        </picture>
        <h1>{{ errorConfig.title }}</h1>
        <p>{{ errorConfig.message }}</p>
        <a class="btn btn-primary" (click)="flights()">
            {{ errorConfig.buttonText || "Go Back Home" }}
        </a>
    </div>
</div>
